import React from "react";
import { Select } from "@mui/material";

const DSSelect = (props: React.ComponentProps<typeof Select>) => {
  return <Select {...props} />;
};

export default DSSelect;
